/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AudioEnum {
  EN = 'EN',
  ES = 'ES',
  PT = 'PT',
}

export enum AutomationConditionalTypesEnum {
  AC_BEGINS_WITH = 'AC_BEGINS_WITH',
  AC_CONTAINS = 'AC_CONTAINS',
  AC_ENDS_WITH = 'AC_ENDS_WITH',
  AC_EQUAL_TO = 'AC_EQUAL_TO',
  AC_NOT_CONTAINS = 'AC_NOT_CONTAINS',
  AC_NOT_EQUAL_TO = 'AC_NOT_EQUAL_TO',
}

export enum AutomationRuleTypeEnum {
  AUTOMATION_RULE_TYPE_ONBOARDING = 'AUTOMATION_RULE_TYPE_ONBOARDING',
  AUTOMATION_RULE_TYPE_SKILL_XP = 'AUTOMATION_RULE_TYPE_SKILL_XP',
}

export enum B2bQuizStatusEnum {
  APPROVED = 'APPROVED',
  CERTIFICATE = 'CERTIFICATE',
  DISAPPROVED = 'DISAPPROVED',
  INCOMPLETE = 'INCOMPLETE',
  INITIAL = 'INITIAL',
  NOT_STARTED = 'NOT_STARTED',
  PROGRESS = 'PROGRESS',
}

export enum B2bQuizTimeLimitEnum {
  TIME_120_MIN = 'TIME_120_MIN',
  TIME_30_MIN = 'TIME_30_MIN',
  TIME_45_MIN = 'TIME_45_MIN',
  TIME_60_MIN = 'TIME_60_MIN',
  TIME_WITHOUT = 'TIME_WITHOUT',
}

export enum CourseB2BSourceEnum {
  ADMIN = 'ADMIN',
  CATALOG = 'CATALOG',
  DIRECT_ASSIGNMENT = 'DIRECT_ASSIGNMENT',
  RECOMMENDATION = 'RECOMMENDATION',
  REWARDS = 'REWARDS',
  TEAM = 'TEAM',
}

export enum CourseTypeEnum {
  B2B = 'B2B',
  B2B_CLASSROOMS = 'B2B_CLASSROOMS',
  DEGREE = 'DEGREE',
  FREE = 'FREE',
  FREEMIUM = 'FREEMIUM',
  HIDDEN = 'HIDDEN',
  MEMBERSHIP = 'MEMBERSHIP',
  PAID = 'PAID',
  PARTNER = 'PARTNER',
  ROCKSTAR = 'ROCKSTAR',
  TEMPORAL_ACCESS = 'TEMPORAL_ACCESS',
}

export enum CoursesReportSheetsEnum {
  COURSES_MAIN_SHEET = 'COURSES_MAIN_SHEET',
  COURSES_QUESTIONS_ANSWERS_SHEET = 'COURSES_QUESTIONS_ANSWERS_SHEET',
  COURSES_RESULTS_BY_USERS_SHEET = 'COURSES_RESULTS_BY_USERS_SHEET',
}

export enum FileUploadStatusEnum {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
}

export enum GeneralReportSheetsEnum {
  ACTIVITY_SHEET = 'ACTIVITY_SHEET',
  COURSE_SHEET = 'COURSE_SHEET',
  GENERAL_SHEET = 'GENERAL_SHEET',
  PERFORMANCE_SHEET = 'PERFORMANCE_SHEET',
}

export enum IntegrationContentTypeEnum {
  AUDIO = 'AUDIO',
  COURSE = 'COURSE',
  READING = 'READING',
  TEST = 'TEST',
  VIDEO = 'VIDEO',
  WORKSHOP = 'WORKSHOP',
}

export enum IntegrationKind {
  LMS = 'LMS',
  THIRD_PARTY_CONTENT = 'THIRD_PARTY_CONTENT',
  WORKPLACE_APP = 'WORKPLACE_APP',
}

export enum IntegrationSupportedPlatformsEnum {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
}

export enum IntegrationType {
  ADD_TO = 'ADD_TO',
  APP_STORE = 'APP_STORE',
  CONNECT = 'CONNECT',
  CONTACT = 'CONTACT',
}

export enum OrganizationReportGenerationFrequencyEnum {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
}

export enum OrganizationReportGenerationWeekDayEnum {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
}

export enum OrganizationReportTypeEnum {
  REPORT_B2B_COURSES = 'REPORT_B2B_COURSES',
  REPORT_B2B_ELEVATE_COURSES = 'REPORT_B2B_ELEVATE_COURSES',
  REPORT_B2B_GENERAL = 'REPORT_B2B_GENERAL',
  REPORT_B2B_LEADERS = 'REPORT_B2B_LEADERS',
  REPORT_B2B_LIVE_SESSIONS = 'REPORT_B2B_LIVE_SESSIONS',
  REPORT_B2B_NOT_STUDYING_USERS = 'REPORT_B2B_NOT_STUDYING_USERS',
  REPORT_B2B_PENDING_USERS = 'REPORT_B2B_PENDING_USERS',
  REPORT_B2B_QUIZZ_RESPONSES_BY_CLASSES = 'REPORT_B2B_QUIZZ_RESPONSES_BY_CLASSES',
  REPORT_B2B_RESULT_QUIZZ_BY_CLASSES = 'REPORT_B2B_RESULT_QUIZZ_BY_CLASSES',
  REPORT_B2B_TRACKS = 'REPORT_B2B_TRACKS',
  REPORT_B2B_USERS = 'REPORT_B2B_USERS',
  REPORT_CENTRALIZED_USERS = 'REPORT_CENTRALIZED_USERS',
}

export enum OrganizationRoleEnum {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_CORPORATION = 'ROLE_CORPORATION',
  ROLE_INDUCTION = 'ROLE_INDUCTION',
  ROLE_MEMBERS = 'ROLE_MEMBERS',
  ROLE_OWNER = 'ROLE_OWNER',
}

export enum ProjectStatusEnum {
  CERTIFIED = 'CERTIFIED',
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  OBSERVED = 'OBSERVED',
  PUBLISHED = 'PUBLISHED',
}

export enum ProjectTeamEnum {
  NO_PROJECT = 'NO_PROJECT',
  ORGANIZATION_CHOICE = 'ORGANIZATION_CHOICE',
  STUDENT_CHOICE = 'STUDENT_CHOICE',
}

export enum ReportFileFormatEnum {
  CSV_FORMAT = 'CSV_FORMAT',
  XLSX_FORMAT = 'XLSX_FORMAT',
}

export enum ReportGenerationTypeEnum {
  ON_DEMAND = 'ON_DEMAND',
  SCHEDULED = 'SCHEDULED',
}

export enum SkillXpTestStatusEnum {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
}

export enum SubtitleEnum {
  EN = 'EN',
  ES = 'ES',
  PT = 'PT',
}

export enum TeamTypeEnum {
  TEAM_TYPE_ACADEMY = 'TEAM_TYPE_ACADEMY',
  TEAM_TYPE_TRACK = 'TEAM_TYPE_TRACK',
}

export enum TracksReportSheetsEnum {
  GENERAL_SHEET = 'GENERAL_SHEET',
  STUDENTS_SHEET = 'STUDENTS_SHEET',
}

export enum TypePlanRequestedEnum {
  ELEVATE = 'ELEVATE',
  LITE = 'LITE',
}

export enum UserOrganizationRoleEnum {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_CORPORATION = 'ROLE_CORPORATION',
  ROLE_INDUCTION = 'ROLE_INDUCTION',
  ROLE_MEMBERS = 'ROLE_MEMBERS',
}

export enum UserOrganizationStatusEnum {
  STATUS_USERS_ACTIVE = 'STATUS_USERS_ACTIVE',
  STATUS_USERS_DELETE = 'STATUS_USERS_DELETE',
  STATUS_USERS_INACTIVE = 'STATUS_USERS_INACTIVE',
  STATUS_USERS_PENDING = 'STATUS_USERS_PENDING',
}

export enum UserTeamFilterEnum {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_MEMBER = 'ROLE_MEMBER',
  TRACK_COMPLETED = 'TRACK_COMPLETED',
  TRACK_IN_PROGRESS = 'TRACK_IN_PROGRESS',
}

export enum UsersReportSheetsEnum {
  USERS_SHEET = 'USERS_SHEET',
}

export enum UsersUploadTypeEnum {
  USER_ORGANIZATION = 'USER_ORGANIZATION',
  USER_WORK_TEAM = 'USER_WORK_TEAM',
}

export interface AssignWorkflowUsersInput {
  organizationSlug: string;
  workflowId: string;
  emails: string[];
  clientMutationId?: string | null;
}

export interface AutomationConditionalInput {
  customFieldId: any;
  conditionalType: AutomationConditionalTypesEnum;
  textValue?: string | null;
  listValue?: (string | null)[] | null;
}

export interface AutomationConditionalUpdateInput {
  automationConditionalId?: any | null;
  customFieldId: any;
  conditionalType: AutomationConditionalTypesEnum;
  textValue?: string | null;
  listValue?: (string | null)[] | null;
}

export interface B2BTagCreateInput {
  name?: string | null;
  attributeId?: string | null;
}

export interface CategoryIdInput {
  categoryId: string;
}

export interface CourseAcademyInput {
  originalId?: string | null;
  isRequired?: boolean | null;
  isRequiredProject?: boolean | null;
}

export interface CreateInductionPhasesInput {
  organizationSlug: string;
  phases: (PhaseInput | null)[];
  clientMutationId?: string | null;
}

export interface CreateOrganizationChildrenInput {
  name: string;
  adminEmail: string;
  adminName: string;
  expireDate: string;
  limitPay: number;
  userId: string;
  parentSlug: string;
  countryId: string;
  clientMutationId?: string | null;
}

export interface CreateTestOrgInput {
  name: string;
  organizationSlug: string;
  categoriesIds?: (CategoryIdInput | null)[] | null;
  listSkillIds?: (SkillIdInput | null)[] | null;
  startDate: string;
  endDate: string;
  usersOrg?: (UserOrganizationIdInput | null)[] | null;
  createdBy: number;
  language: string;
  templateSlug?: string | null;
  test?: boolean | null;
  clientMutationId?: string | null;
}

export interface CreateUserConfigOrganizationInput {
  organizationUserId: number;
  classroomTour?: boolean | null;
  skillIqTour?: boolean | null;
  projectTour?: boolean | null;
  adminTour?: boolean | null;
  statisticsTour?: boolean | null;
  clientMutationId?: string | null;
}

export interface CreateUserOrganizationInput {
  organizationSlug: string;
  users?: (UserOrganizationCreateInput | null)[] | null;
  sendActivationEmail?: boolean | null;
  clientMutationId?: string | null;
}

export interface CustomFieldInput {
  customFieldTypeId: string;
  customFieldType: string;
  name: string;
  description?: string | null;
  maxLength?: number | null;
  isMultiple?: boolean | null;
  options?: (CustomFieldOptionInput | null)[] | null;
}

export interface CustomFieldInputUpdate {
  name?: string | null;
  description?: string | null;
  maxLength?: number | null;
  isMultiple?: boolean | null;
  isActive?: boolean | null;
  canEdit?: boolean | null;
  canDelete?: boolean | null;
  isDefault?: boolean | null;
  isHidden?: boolean | null;
  options?: (CustomFieldOptionInput | null)[] | null;
}

export interface CustomFieldOptionInput {
  id?: number | null;
  optionName: string;
}

export interface CustomFieldUserAnswer {
  customFieldId?: string | null;
  answer: (string | null)[];
}

export interface EnrollUsersToCourseInput {
  userIds: (string | null)[];
  courseId: string;
  organizationSlug: string;
  source: CourseB2BSourceEnum;
  userTeamIds?: (string | null)[] | null;
  clientMutationId?: string | null;
}

export interface ExtendSkillXpTestEndDateInput {
  testId: number;
  endDate: string;
  logData?: LogDataInput | null;
  clientMutationId?: string | null;
}

export interface LogDataInput {
  userOrgId?: string | null;
  userOrgName?: string | null;
  userEmail?: string | null;
  organizationId?: string | null;
  organizationName?: string | null;
}

export interface PhaseInput {
  name: string;
  description?: string | null;
}

export interface ReportFilterCustomFieldInput {
  customFieldId?: string | null;
  answers?: (string | null)[] | null;
}

export interface SkillIdInput {
  skillId: string;
}

export interface SkillPathTeamInput {
  skillPathId?: string | null;
  isRequiredQuiz?: boolean | null;
  projectType: ProjectTeamEnum;
  coursesAcademy?: (CourseAcademyInput | null)[] | null;
  requiredProjects?: number | null;
}

export interface UpdateInductionPhaseInput {
  phaseId: string;
  name: string;
  description?: string | null;
  clientMutationId?: string | null;
}

export interface UpdateOrganizationInput {
  slug: string;
  parentSlug?: string | null;
  name?: string | null;
  source?: string | null;
  industrySlug?: string | null;
  replicate?: boolean | null;
  countryId?: string | null;
  expireDate?: string | null;
  limitPay?: number | null;
  adminEmail?: string | null;
  adminName?: string | null;
  clientMutationId?: string | null;
}

export interface UpdateUserB2BInput {
  organizationSlug: string;
  userOrgId: number;
  user?: UserOrganizationUpdateInput | null;
  clientMutationId?: string | null;
}

export interface UserCustomFieldInput {
  userOrgId?: number | null;
  customFieldId?: any | null;
  answer?: string | null;
}

export interface UserMassiveUploadDetailErrorInput {
  email?: string | null;
  message?: string | null;
}

export interface UserMassiveUploadErrorInput {
  code?: number | null;
  error?: string | null;
  subErrors?: (UserMassiveUploadSubErrorInput | null)[] | null;
}

export interface UserMassiveUploadSubErrorInput {
  subCode?: number | null;
  errors?: (UserMassiveUploadDetailErrorInput | null)[] | null;
}

export interface UserOrganizationCreateInput {
  email: string;
  firstName: string;
  lastName: string;
  teamId?: number | null;
  departament?: string | null;
  subDepartament?: string | null;
  password?: string | null;
  tags?: (string | null)[] | null;
  role?: string | null;
  inductionStatus?: number | null;
  expirationDate?: string | null;
  source?: string | null;
  replicate?: boolean | null;
  customFields?: (CustomFieldUserAnswer | null)[] | null;
}

export interface UserOrganizationIdInput {
  userOrgId: string;
}

export interface UserOrganizationUpdateInput {
  password?: string | null;
  lastName?: string | null;
  firstName?: string | null;
  subDepartament?: string | null;
  departament?: string | null;
  tags?: (string | null)[] | null;
  email: string;
  teamId?: number | null;
  role?: string | null;
  expirationDate?: string | null;
  inactiveMeta?: string | null;
  status?: number | null;
  isActive?: boolean | null;
  customFields?: (CustomFieldUserAnswer | null)[] | null;
}

export interface UserWorkTeaMassiveInput {
  isLead: boolean;
  workTeamId?: string | null;
  userOrganizationId: string;
}

export interface WorkTeamInput {
  name: string;
  isActive?: boolean | null;
  users?: (UserWorkTeaMassiveInput | null)[] | null;
  tagIds?: (string | null)[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
